import { Category } from 'store/app/types';

const findRootCategory = (categoryId: number, categories: Category[]): Category | null => {
  const category = categories.find((c) => c.categoryId === categoryId);

  if (!category) {
    return null;
  }

  if (!category.parentCategoryId) {
    return category;
  }

  return findRootCategory(category.parentCategoryId, categories);
};

export default findRootCategory;
